import React from 'react';
import { TooltipProps } from '../../../charts/core/tooltip/Tooltip';
import { formatPercentage, formatValue } from '../../../charts/utils/formatters';
import { ChartTooltip } from '../ChartTooltip/ChartTooltip';
import { ChartTooltipItem } from '../ChartTooltip/ChartTooltipItem';
import type { PieWidgetDatum } from './PieWidgetCloneAdapter';

type PieWidgetTooltipProps = { total: number };

export const PieWidgetTooltip = ({
  tooltipData,
  isPinned,
  getColor,
  getValue,
  getIdentifier,
  labelFormatter,
  total,
}: TooltipProps<PieWidgetDatum> & PieWidgetTooltipProps) => {
  const count = getValue(tooltipData);
  const share = total ? count / total : 0;
  return (
    <ChartTooltip
      minWidth={160}
      maxWidth={221}
      boxShadow={t => t.shadows[10]}
      interactionsMenuOpen={isPinned}
      titleSlot={
        <ChartTooltipItem
          dotColor={getColor(tooltipData)}
          title={labelFormatter?.(tooltipData, { where: 'tooltip' }) ?? getIdentifier(tooltipData)}
        />
      }>
      <ChartTooltipItem title="Count" value={formatValue.format(count)} />
      <ChartTooltipItem title="Share" value={formatPercentage.format(share)} />
    </ChartTooltip>
  );
};
